import Vue from 'vue'
import VueRouter from 'vue-router'
import Intro from '../views/Intro.vue'
import Connectivity from '../views/Connectivity.vue'
import Heater from '../views/Heater.vue'
import Controls from '../views/Controls.vue'
import Actuators from '../views/Actuators.vue'
import Detail from '../views/Detail.vue'

Vue.use(VueRouter)

const routes = [
    {
        path: '/',
        name: 'Intro',
        component: Intro
    },
    {
        path: '/connectivity',
        name: 'Connectivity',
        component: Connectivity
    },
    {
        path: '/beheizungen',
        name: 'Heater',
        component: Heater
    },
    {
        path: '/steuerungen',
        name: 'Controls',
        component: Controls
    },
    {
        path: '/aktoren',
        name: 'Actuators',
        component: Actuators
    },
    {
        path: '/:category/:name',
        name: 'Detail',
        component: Detail
    },
    {
        path: '/*',
        redirect: '/'
    }
]

const router = new VueRouter({
    mode: 'history',
    base: process.env.BASE_URL,
    routes
})

export default router
